module.exports = __webpack_public_path__ + "static/TiemposText-SemiboldItalic-abedb1c8b8098e22d89ec6553fef5722.ttf";